/**
 * Common Catalog Fields to used in master data, inventory and pricing
 */
const commonCatalogFields = {
  ITEM_NUMBER: {
    key: 'itemNo',
    label: 'Item No',
  },
  BARCODE: {
    key: 'barcode',
    label: 'Barcode',
  },
  DEPARTMENT: {
    key: 'dept',
    label: 'Department',
  },
  SECTION: {
    key: 'section',
    label: 'Section',
  },
  FAMILY: {
    key: 'family',
    label: 'Family',
  },
  SUB_FAMILY: {
    key: 'subFamily',
    label: 'Sub Family',
  },
  SAP_DEPARTMENT: {
    key: 'sapDept',
    label: 'SAP Department',
  },
  SAP_SECTION: {
    key: 'sapSection',
    label: 'SAP Section',
  },
  SAP_FAMILY: {
    key: 'sapFamily',
    label: 'SAP Family',
  },
  SAP_SUB_FAMILY: {
    key: 'sapSubFamily',
    label: 'SAP Sub Family',
  },
  ERP_ITEM_DESC: {
    key: 'description',
    label: 'ERP Item Description',
  },
  ERP_UOM: {
    key: 'uom',
    label: 'ERP UOM',
  },
  QTY_PER_UOM: {
    key: 'qtyPerUom',
    label: 'QTY Per UOM',
  },
  ERP_PACK_INFO: {
    key: 'uomPackagingInfo',
    label: 'ERP Pack Info',
  },
  ERP_BRAND: {
    key: 'erpBrand',
    label: 'ERP Brand',
  },
  ONLINE_DESC: {
    key: 'onlineDesc',
    label: 'Online Description',
  },
  ONLINE_PACK_INFO: {
    key: 'onlinePackInfo',
    label: 'Online Pack Info',
  },
}

/**
 * Master Data Form Fields
 */
const MASTER_DATA_FORM_FIELDS = {
  ...commonCatalogFields,
  IMAGE: {
    key: 'image',
    label: 'Product Image',
  },
  CATEGORY: {
    key: 'category',
    label: 'Category',
  },
  MAIN_CATEGORY: {
    key: 'mainCategory',
    label: 'Main Category',
  },
  CLASSIFICATION: {
    key: 'classification',
    label: 'Classification',
  },
  IS_LOOSE_ITEM: {
    key: 'isLooseItem',
    label: 'Loose Item',
  },
  IS_SCALE_ITEM: {
    key: 'isScaleItem',
    label: 'Scale Item',
  },
  QUANTITY_STEP: {
    key: 'quantityStep',
    label: 'Qty Step',
  },
  UNIT: {
    key: 'unit',
    label: 'Unit',
  },
  ERP_MARKETING_CODE: {
    key: 'erpMarketingCode',
    label: 'ERP Marketing Code',
  },
  VAT_CLASS: {
    key: 'vatClass',
    label: 'VAT Class',
  },
  VAT_PERCENTAGE: {
    key: 'vatPercentage',
    label: 'VAT Percentage',
  },
  ACTIVE_ONLINE: {
    key: 'activeOnline',
    label: 'Active Online',
  },
  IS_THIRD_PARTY_PRODUCT: {
    key: 'isThirdPartyProduct',
    label: 'Third Party Product',
  },
  BLOCK_ERP_PRICE_SYNC: {
    key: 'blockPriceSync',
    label: 'Block Erp Price Sync',
  },
  HIDE_AGGREGATORS: {
    key: 'hideAggregators',
    label: 'Hide Aggregators',
  },
  ACTIVATED_STORES: {
    key: 'activatedStores',
    label: 'Activated Stores',
  },
  IN_STOCK_STORES: {
    key: 'inStockStores',
    label: 'In Stock Stores',
  },
  IS_AVAILABLE_IN_FRESH: {
    key: 'isAvailableInFresh',
    label: 'Available In Fresh',
  },
  IS_FRESH_PREPARATION: {
    key: 'freshPreparation',
    label: 'Fresh Preparation',
  },
  FRESH_CATEGORIES: {
    key: 'freshCategories',
    label: 'Fresh Categories',
  },
  PLU: {
    key: 'plu',
    label: 'PLU',
  },
  DELIVEROO_MAX_QUANTITY: {
    key: 'deliverooMaxQtyLimit',
    label: 'Deliveroo Max Qty Limit',
  },
  TALABAT_MAX_QUANTITY: {
    key: 'talabatMaxQtyLimit',
    label: 'Talabat Max Qty Limit',
  },
  SAP_MATERIAL_NO: {
    key: 'sapMaterialNo',
    label: 'Sap Material No',
  },
  SPECIAL_CATEGORY: {
    key: 'specialCategories',
    label: 'Special Categories',
  },
  IS_DISABLE: {
    key: 'isDisable',
    label: 'Is Disable',
  },
  LAST_DISABLE_TIME: {
    key: 'lastDisableTime',
    label: 'Last Disable Time',
  },
  STORES: {
    key: 'stores',
    label: 'Stores',
  },
  CHAINS: {
    key: 'chains',
    label: 'Chains',
  },
  CREATED_AT: {
    key: 'createdAt',
    label: 'Created At',
  },
  UPDATED_AT: {
    key: 'updatedAt',
    label: 'Updated At',
  },
  IS_BUNDLE_PRODUCT: {
    key: 'isBundleProduct',
    label: 'Is Bundle Product',
  },
}

/**
 * Pricing Form Fields
 */
const PRICING_FORM_FIELDS = {
  ...commonCatalogFields,
  STORE_NAME: {
    key: 'storeName',
    label: 'Store Name',
  },
  ERP_PRICE: {
    key: 'erpPrice',
    label: 'ERP Price',
  },
  STORE_ID: {
    key: 'storeId',
    label: 'Store ID',
  },
  SPECIAL_PRICE: {
    key: 'specialPrice',
    label: 'Special Price',
  },
  SPECIAL_PRICE_START_DATE: {
    key: 'specialPriceStartDate',
    label: 'Special Price Start Date',
  },
  SPECIAL_PRICE_END_DATE: {
    key: 'specialPriceEndDate',
    label: 'Special Price End Date',
  },
  SPECIAL_PRICE_START_TIME: {
    key: 'specialPriceStartTime',
    label: 'Special Price Start Time (GST)',
  },
  SPECIAL_PRICE_END_TIME: {
    key: 'specialPriceEndTime',
    label: 'Special Price End Time (GST)',
  },
  PROMO: {
    key: 'promo',
    label: 'Promo',
  },
  PROMO_START_DATE: {
    key: 'promoStartDate',
    label: 'Promo Start Date',
  },
  PROMO_END_DATE: {
    key: 'promoEndDate',
    label: 'Promo End Date',
  },
  AGGREGATOR_ID: {
    key: 'aggregator',
    label: 'Aggregator ID',
  },
  TEMP_ERP_PRICE: {
    key: 'tempErpPrice',
    label: 'Temp Erp Price',
  },
  ONLINE_PRICE: {
    key: 'onlinePrice',
    label: 'Online Price',
  },
  ACTIVE_PRICE: {
    key: 'activePrice',
    label: 'Active Price',
  },
  LAST_PRICE_UPDATE: {
    key: 'updatedAt',
    label: 'Last Price Update',
  },
  SLASH_PRICE: {
    key: 'slashPrice',
    label: 'Slash Price',
  },
  SLASH_PRICE_START_DATE: {
    key: 'slashPriceStartDate',
    label: 'Slash Price Start Date',
  },
  SLASH_PRICE_END_DATE: {
    key: 'slashPriceEndDate',
    label: 'Slash Price End Date',
  },
  BLOCK_SALE_ON_POS: {
    key: 'blockSaleOnPos',
    label: 'Block Sale On POS',
  },
  CLUSTER: {
    key: 'cluster',
    label: 'Cluster',
  },
  CREATED_AT: {
    key: 'createdAt',
    label: 'Created At',
  },
  UPDATED_AT: {
    key: 'updatedAt',
    label: 'Updated At',
  },
}

/**
 * Ecom Pricing Form Fields
 */
const ECOM_PRICING_FORM_FIELDS = {
  BARCODE: {
    key: 'barcode',
    label: 'Barcode',
  },
  CLUSTER: {
    key: 'cluster',
    label: 'Cluster',
  },
  BASE_PRICE: {
    key: 'basePrice',
    label: 'Base Price',
  },
  SPECIAL_PRICE: {
    key: 'specialPrice',
    label: 'Special Price',
  },
  SPECIAL_PRICE_START_DATE: {
    key: 'specialPriceFromDate',
    label: 'Special Price Start Date (DD/MM/YYYY)',
    placeholder: 'Special Price Start Date',
  },
  SPECIAL_PRICE_END_DATE: {
    key: 'specialPriceToDate',
    label: 'Special Price End Date (DD/MM/YYYY)',
    placeholder: 'Special Price End Date',
  },
  CREATED_AT: {
    key: 'createdAt',
    label: 'Created At',
  },
  UPDATED_AT: {
    key: 'updatedAt',
    label: 'Updated At',
  },
}

/**
 * Inventory Form Fields
 */
const INVENTORY_FORM_FIELDS = {
  ...commonCatalogFields,
  STORE_NAME: {
    key: 'storeName',
    label: 'Store Name',
  },
  STORE_ID: {
    key: 'storeId',
    label: 'Store ID',
  },
  LAST_QTY_UPDATE: {
    key: 'lastUpdatedOnErp',
    label: 'Last QTY Update',
  },
  ERP_QTY: {
    key: 'erpQty',
    label: 'ERP QTY',
  },
  OOS_THRESHOLD: {
    key: 'oosThreshold',
    label: 'OOS Threshold',
  },
  SELLABLE_QTY: {
    key: 'sellableQty',
    label: 'Sellable QTY',
  },
  ON_STOCK: {
    key: 'isOnStock',
    label: 'In Stock',
  },
  USE_GLOBAL_THRESHOLD: {
    key: 'useGlobalThreshold',
    label: 'Use Global Threshold',
  },
  IGNORE_UPDATE_TO_MAGENTO: {
    key: 'ignoreUpdateToMagento',
    label: 'Ignore Update To Magento',
  },
  BLOCK_ERP_INVENTORY: {
    key: 'blockErpInventory',
    label: 'Block Erp Inventory',
  },
  ALLOW_ERP_WINDOW_UPDATE: {
    key: 'allowErpWindowUpdate',
    label: 'Allow Erp Window Update',
  },
  BLOCK_FRESH_ERP_INVENTORY: {
    key: 'blockFreshInventory',
    label: 'Block Fresh Availability Inventory',
  },
  CREATED_AT: {
    key: 'createdAt',
    label: 'Created At',
  },
  UPDATED_AT: {
    key: 'updatedAt',
    label: 'Updated At',
  },
} as const

export {
  INVENTORY_FORM_FIELDS,
  PRICING_FORM_FIELDS,
  MASTER_DATA_FORM_FIELDS,
  ECOM_PRICING_FORM_FIELDS,
}
